import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
  gql,
} from '@apollo/client';
import { offsetLimitPagination } from '@apollo/client/utilities';
import { onError } from '@apollo/client/link/error';

const baseConfig = {
  uri: process.env.GRAPHQL_API,
  credentials: 'include',
  headers: {
    'x-buffer-client-id': 'webapp-publishing',
  },
};

const ErrorLink = onError(({ graphQLErrors, networkError, operation }) => {
  const { bugsnagClient } = window;
  if (bugsnagClient) {
    const metaData = {
      GraphQL: {
        operationName: operation?.operationName ?? 'undefined',
        variables: operation?.variables,
        graphQLErrors: graphQLErrors?.map((e) => e.message),
      },
    };
    const error = networkError ?? new Error('Unknown GraphQL error');
    bugsnagClient.notify(error, { metaData });
  }
});

const NormalLink = new HttpLink(baseConfig);
const MockLink = new HttpLink({
  ...baseConfig,
  uri: process.env.GRAPHQL_MOCK_API,
});

/**
 * Look at the query to determine whether to send to the mock or production API.
 * https://www.apollographql.com/docs/react/api/link/introduction/#directional-composition
 */
const MockOrNormalLink = ApolloLink.split(
  (operation) => operation.getContext().mock === true,
  MockLink,
  NormalLink
);

const client = new ApolloClient({
  link: ApolloLink.from([ErrorLink, MockOrNormalLink]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          ideas: {
            // as we are using pagination for Ideas,
            // we need to tell the cache how to merge data
            keyArgs: false,
            merge(
              existing = {
                pageInfo: {},
                edges: [],
                __typename: '',
              },
              incoming
            ) {
              const data = {
                __typename: incoming.__typename,
                pageInfo: {
                  ...incoming.pageInfo,
                },
                edges: [...existing.edges, ...incoming.edges],
              };
              return data;
            },
          },
        },
      },
    },
  }),
});

export { client, gql };
